import getApiBaseUrl from '@/utils/getBaseUrl';
import { useQuery } from '@tanstack/react-query';

export interface Profile {
  emailAddress: string;
  firstName: string;
  lastName?: string;
  auth0Id: string;
  createdAt: string;
  phoneNumber?: string;
  role?: 'AGENT';
  companyName?: string;
  licenseNumber?: string;
  photoUrl?: string;
  website?: string;
}

export default function useGetAgent(agent?: string) {
  return useQuery<Profile>({
    queryKey: ['AGENT'],
    queryFn: async () => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/users/agent/${agent}`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
    enabled: !!agent,
  });
}
